<template>
  <div></div>
</template>
<script>
export default {
  data() {
    return {
      mappedItem: undefined,
      isGiftCard: false,
      isEGiftCard: false,
      isPocketmagsPlus: false,
      isBookazine: false,
      isMagazine: false,
      isNewspaper: false,
      isCrossSell: false,
      isDefaultProduct: false // Should be Magazine, Newspaper, ...
    }
  },
  computed: {},
  mounted() {
    if (this.$nuxt.$config.MongoDBIntegration) {
      console.log('BaseProductMixin MongoDB')
      this.isGiftCard = this.item?.type === 'GIFTCARD' || false
      this.isEGiftCard = this.item?.type === 'EGIFTCARD' || false
      this.isPocketmagsPlus = this.item?.type === 'POCKETMAGSPLUS' || false
      // this.isBookazine = this.item?.offer?.name?.toLowerCase().includes('bookazine') || false
      this.isMagazine = this.item?.type === 'MAGAZINE' || false
      this.isNewspaper = this.item?.type === 'NEWSPAPER' || false
      this.isCrossSell = this.item?.type === 'CROSS_SELL' || this.item?.type === 'GENERIC' || false
      this.isDefaultProduct = !this.isEGiftCard && !this.isGiftCard && !this.isPocketmagsPlus
      this.mappedItem = this.item
    } else {
      console.log('BaseProductMixin Magento')
      this.isGiftCard = this.item?.id === 'GIFT' || false
      this.isEGiftCard = this.item?.id === 'EGFT' || false
      this.isPocketmagsPlus = this.item?.id === 'PLUS' || false
      this.isBookazine = this.item?.title?.toLowerCase().includes('bookazine') || false
      this.isDefaultProduct = !this.isEGiftCard && !this.isGiftCard && !this.isPocketmagsPlus
      this.mappedItem = this.item
    }
  },

  methods: {
    getBasketId() {
      return this.$store.getters['basket/id']
    },
    getItemData(key, extras = {}) {
      let value
      let custom

      if (this.mappedItem === undefined) {
        return value
      }

      if (this.$nuxt.$config.MongoDBIntegration) {
        // console.info(`MONGODB Item Mapping for key='${key}' item=`, this.mappedItem)

        switch (key) {
          case 'title':
            value = this.mappedItem?.title || this.mappedItem?.offer?.name
            break
          case 'offer_name':
            value = this.mappedItem?.offer?.name
            break
          case 'pkmg_title':
            value = this.mappedItem.custom_fields.offer.title
            break
          case 'image_src':
            value = `${this.$config.imgixURL}${this.mappedItem.image_path}`
            switch (this.mappedItem.type) {
              case 'GIFTCARD':
                custom = `&mask=corners&corner-radius=20,20,20,20&mask-bg=0FFF`
                value = `${this.$config.imgixURL}${this.mappedItem.custom_fields.design.image || '/gift-card-images/JMAG_Giftcards.png'}`
                value += extras?.imageSrcQS ? extras.imageSrcQS + custom : `?fm=png&auto=format&w=360${custom}`
                break
              case 'EGIFTCARD':
                custom = `&mask=corners&corner-radius=20,20,20,20&mask-bg=0FFF`
                value = `${this.$config.imgixURL}${this.mappedItem.custom_fields.design.image || '/gift-card-images/JMAG_Giftcards.png'}`
                value += extras?.imageSrcQS ? extras.imageSrcQS + custom : `?fm=png&auto=format&w=360${custom}`
                break

              case 'POCKETMAGSPLUS':
                custom = `&mask=corners&corner-radius=20,20,20,20&mask-bg=0FFF&border=1,070707`
                value = `${this.$config.imgixURL}/pocketmagsplus/image.png`
                value += extras?.imageSrcQS ? extras.imageSrcQS + custom : `?fm=png&auto=format&w=360${custom}`
                break

              default:
                custom = ''
                value = `${this.$config.imgixURL}${this.mappedItem.image_path}`
                value += extras?.imageSrcQS ? extras.imageSrcQS + custom : `?fm=png&auto=format&w=360${custom}`
                break
            }
            break
          case 'url_path':
            value = this.mappedItem[key]
            break
          case 'gift_card_id':
            value = this.mappedItem.id
            break
          case 'message':
            value = this.mappedItem?.custom_fields?.message
            break
          case 'short_message':
            value = (this.mappedItem.custom_fields.message.length > 50 && this.mappedItem.custom_fields.message.substring(0, 50) + '...') || this.mappedItem.custom_fields.message
            break

          case 'edit_url':
            switch (this.mappedItem.type) {
              case 'GIFTCARD':
                value = `/magazines/gift-cards/${this.$store.getters['basket/id']}/${this.mappedItem.id}`
                break
              case 'EGIFTCARD':
                value = `/magazines/e-giftcards/${this.$store.getters['basket/id']}/${this.mappedItem.id}`
                break
              case 'POCKETMAGSPLUS':
                value = `/magazines/pocketmagsplus/${this.$store.getters['basket/id']}/${this.mappedItem.id}`
                break
              default:
                break
            }
            break
          case 'delete_url':
            switch (this.mappedItem.type) {
              case 'GIFTCARD':
                value = `${this.$config.imgixURL}${this.mappedItem.custom_fields.design.image || '/gift-card-images/JMAG_Giftcards.png'}`
                value += `?fm=png&auto=format&w=360&mask=corners&corner-radius=20,20,20,20&mask-bg=0FFF`
                break

              default:
                break
            }
            break
          case 'from_name':
            value = this.mappedItem.custom_fields.fromName
            break
          case 'to_email':
            value = this.mappedItem.custom_fields.toEmail
            break
          case 'to_name':
            value = this.mappedItem.custom_fields.toName
            break
          case 'to_date':
            value = new Date(this.mappedItem.custom_fields.toDate).toLocaleDateString('en-GB')
            break
          case 'num_of_issues':
            value = this.mappedItem.offer.num_of_issues
            break
          case 'num_of_issues_label':
            value = `${this.mappedItem.offer.num_of_issues} issue${this.mappedItem.offer.num_of_issues >= 1 && 's'}`
            break
          case 'free_gift':
            if (!this.mappedItem?.offer?.free_gift?.enabled) {
              return undefined
            }
            value = this.mappedItem?.offer?.free_gift?.text
            break

          default:
            value = this.mappedItem[key]
            break
        }
      } else {
        console.info(`LEGACY Item Mapping for key='${key}' item=`, this.item)

        switch (key) {
          case 'pkmg_title':
            value = `${this.item.offer.label} Saving ${this.item.offer.save}%`
            break
          case 'image_src':
            value = `${this.$config.imgixURL}${this.item.imageUrl}`
            break
          case 'url_path':
            value = '/' + this.item.url
            break
          case 'gift_card_id':
            value = this.item.offer.giftcardId
            break
          case 'message':
            value = this.item?.offer?.message
            break
          case 'short_message':
            value = (this.item.offer.message.length > 50 && this.item.offer.message.substring(0, 50) + '...') || this.item.offer.message
            break
          case 'from_name':
            value = this.item.offer.fromName
            break
          case 'to_email':
            value = this.item.offer.toEmail
            break
          case 'to_name':
            value = this.item.offer.toName
            break
          case 'to_date':
            value = this.item.offer.toDate
            break

          default:
            value = this.item[key]
            break
        }
      }

      // console.info(`MONGODB Item Mapping for key='${key}' value=${value} item=`, this.mappedItem)
      return value
    }
  }
}
</script>
